<template>
    <div>
        <div v-if="sModoCampo=='1' || sModoCampo=='2'">
            <span class="text-label-primary segundoEstiloTitulo">
                {{ onValidarJSON('label') }} <span v-if="bObligatorio" class="red--text">*</span>
            </span>
            <div class="alertInformativo">
                <v-row>
                    <v-col cols="1"><v-icon color="primary">mdi-information</v-icon></v-col>
                    <v-col>
                        <span class="subtitle-2 font-weight-black">{{ onValidarJSON('titulo') }}</span> <br>
                        <span class="subtitle-2 font-weight-bold">{{ onValidarJSON('subtitulo') }}</span> <br>
                        <span>{{ onValidarJSON('descripcion') }}</span>
                        <template v-if="onValidarJSON('subtitulo2')!=''">
                            <br>
                            <span class="subtitle-2 font-weight-bold">{{ onValidarJSON('subtitulo2') }}</span> <br>
                            <span>{{ onValidarJSON('descripcion2') }}</span>
                        </template>
                    </v-col>
                </v-row>
            </div>
            <v-row class="px-1">
                <v-col cols="9">
                    <v-textarea
                        v-model="sBuscador"
                        v-bind="oAtributos"
                        :disabled="bBloaquear"
                        class="mt-1 custom-border"
                        dense
                        outlined
                        :placeholder="onValidarJSON('placeholder')"
                        auto-grow
                        rows="1"
                        hide-details
                    />
                </v-col>
                <v-col cols="2" class="text-left">
                    <v-btn
                        color="primary"
                        elevation="0"
                        icon
                        :disabled="bBloaquear"
                        x-large
                        class="mb-1 btnBuscador"
                        @click="onConsultar" >
                        <v-icon size="28" color="white">
                            mdi-plus
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <div class="alertInformativo2">
                <span>{{ onValidarJSON('infoExtra') }}</span>
            </div>
            <div class="alertError" v-if="oMensajeDetalle.bMostrar">
                <span><v-icon color="red" class="mr-2">mdi-information-outline</v-icon>{{ oMensajeDetalle.sMensaje }}</span>
            </div>
            <v-row class="mt-3 pr-4" v-if="aDatosEncontrados?.length>0">
                <v-col cols="8" class="textoBusqueda">Elemento a entregar</v-col>
                <v-col cols="4" class="d-flex justify-center"><v-btn block outlined color="red" @click="onEliminarElemento(-1)"><v-icon color="red">mdi-delete</v-icon> Eliminar</v-btn></v-col>
            </v-row>
            <div class="alertInformativo2" v-if="nErrores>0">
                <v-row>
                    <v-col cols="2"><v-icon color="orange" size="28">mdi-information-outline</v-icon></v-col>
                    <v-col><span><strong>Hay {{ nErrores }} ID(s) inválido(s) en la lista</strong>
                        <br>Puede eliminarlos manualmente o, si confirma la entrega, estos IDs inválidos se omitirán automáticamente.</span></v-col>
                </v-row>
            </div>
            <div v-if="aDatosEncontrados?.length > 0" class="custom-scroll mt-4" style="max-height: 400px; padding-right: 8px;">
                <v-row dense>
                    <v-col cols="12" v-for="oElemento in aDatosEncontrados" :key="oElemento.idElemento" class="mb-2">
                    <v-alert outlined
                            :color="oElemento?.sErrorElemento=='' ? '#B9F8CF' : 'red'"
                            text>
                        <v-row class="align-center" no-gutters>
                        <v-col cols="2">
                            <v-icon v-if="oElemento?.sErrorElemento==''" color="#016630" size="28">mdi-check</v-icon>
                            <v-icon v-else color="red" size="28">mdi-information-outline</v-icon>
                        </v-col>
                        <v-col cols="8">
                            <span :class="oElemento?.sErrorElemento=='' ? 'elemento' : 'elementoError'"
                                @click="onMostrarElemento(oElemento)">
                            {{ oElemento?.idElemento }}
                            </span>
                            <template v-if="oElemento?.sErrorElemento!=''">
                            <br>
                            {{ oElemento?.sErrorElemento }} - No disponible en esta sede
                            </template>
                        </v-col>
                        <v-col cols="2">
                            <v-btn icon color="red" @click="onEliminarElemento(oElemento?.idElemento)">
                                <v-icon size="28">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                        </v-row>
                    </v-alert>
                    </v-col>
                </v-row>
            </div>
            <span v-if="aDatosEncontrados?.length > 0">Haz click sobre un elemento para ver sus detalles completos (incluye elementos ya entregados)</span>


            <span v-if="bError && aDatosEncontrados?.length==0" style="width: 100%;color: red;">Debe ingresar al menos un ID de registro</span>
        </div>

        <DialogDetalleElemento @onValidacionModalElemento="onValidacionModalElemento"  v-model="oModalDetalleElemento.bModalVisible" :oModalDetalleElemento="oModalDetalleElemento.oModalDetalleElemento"/>
    </div>
</template>

<script>

import axiosServices from "@/services/axiosServices.js"
import DialogDetalleElemento from '@/components/elementosExtraviados/DialogDetalleElemento.vue';

export default {
    name: 'FormBusqueda',
    props: {
        value: {},
        oAtributos: {
            type: Object,
            default: () => {}
        },
        bObligatorio: {
            type: Boolean,
            default: false
        },
        sLabel: {
            type: String,
            default: ''
        },
        sModoCampo:{
            type: String,
            default: "1",
        },
        sGrupo:{
            type: String,
            default: "",
        },
        sCampoModificaA:{
            type: String,
            default: "",
        },
        bError:{
            type: Boolean,
            default: false,
        }
    },
    components: {
        DialogDetalleElemento
    },
    data() {
        return {
            valor: this.value,
            sPlaceholderTemp:"",
            sBuscador:"",
            aDatosEncontrados:[],
            bBloaquear:false,
            oModalDetalleElemento:{
                bModalVisible:false,
                oModalDetalleElemento:{}
            },
            oMensajeDetalle:{
                bMostrar:false,
                sMensaje:""
            },
            nErrores:0

        }
    },
    watch: {
        valor(NewValor) {
            this.$emit('input', NewValor)
        },
        value(NewValor) {
            this.valor = NewValor
        }
    },
    methods: {
        onValidarJSON(sPropiedad){
            try {
                if(this.sLabel!=""){
                    //Validamos que sea un json correcto
                    let oDatos = JSON.parse(this.sLabel);
                    return oDatos[sPropiedad];
                }
            } catch (error) {
                error
                return "";
            }
        },
        async onConsultar(){
            this.nErrores = 0;
            this.oMensajeDetalle.bMostrar = false;
            //Validamos si lo que se va a consultar se consultara
            if(!this.onValidarBuscarElementos()){
                return;
            }
            //El parametor sCampoModificaA, nos trae la url donde debemos consultar, la ruta debe venir finalizando con /$buscar, con el fin de poder remplazar con el campo que estan introducciendo la informacion a buscar
            let sURL = this.sCampoModificaA;
            sURL = sURL.replace("$buscar",this.sBuscador)
            let oResult = await axiosServices.getConfiguration(sURL, true);
            if(oResult?.nStatusCode==200 && oResult?.aData?.length>0){
                this.sBuscador = "";
                if(this.sModoCampo=="1"){
                    this.aDatosEncontrados = oResult?.aData;
                    this.bBloaquear = true;
                }
                else if(this.sModoCampo=="2"){
                    this.aDatosEncontrados = this.aDatosEncontrados.concat(oResult?.aData)
                }
                
                this.valor = this.aDatosEncontrados;

                //Recorremos a ver quien tiene un estado diferente a vigilancia
                this.aDatosEncontrados.forEach((oElementoEncontrado, index, aElementoEncontrado) => {
                    aElementoEncontrado[index].sErrorElemento = "";
                    if(oElementoEncontrado?.idEstado!=1){
                        this.nErrores++;
                        aElementoEncontrado[index].sErrorElemento = oElementoEncontrado?.Estado;
                        aElementoEncontrado[index].bOmitir = true;
                    }
                });
            }
            else{
                this.oMensajeDetalle.sMensaje="El dato no existe";
                this.oMensajeDetalle.bMostrar=true;
            }
        },
        onEliminarElemento(nIdElemento){
            if(nIdElemento==-1){
                this.aDatosEncontrados = [];
            }
            this.aDatosEncontrados = this.aDatosEncontrados.filter(item => item.idElemento != nIdElemento);
            this.valor = this.aDatosEncontrados;
            this.bBloaquear = false;
            //Recorremos los elementos para ver cuantos malos quedan
            this.nErrores = 0;
            this.aDatosEncontrados.forEach(item => {
                if(item?.sErrorElemento!=""){
                    this.nErrores++;
                }
            });
            
        },
        onMostrarElemento(oElemento){
            this.oModalDetalleElemento.oModalDetalleElemento = oElemento;
            this.oModalDetalleElemento.bModalVisible = true;
        },
        onValidacionModalElemento(){
            this.oModalDetalleElemento.bModalVisible = false;
        },
        onValidarBuscarElementos(){
            if (this.sModoCampo === "1" && !/^\d*$/.test(this.sBuscador)) {
                this.oMensajeDetalle.sMensaje = "Solo se permite datos numericos.";
                this.oMensajeDetalle.bMostrar = true;
                return false;
            }
            //Ahora validamos que el id no este en la lista
            let oElementoEncontrado = this.aDatosEncontrados.find(item => item.idElemento == this.sBuscador);
            if(oElementoEncontrado){
                this.oMensajeDetalle.sMensaje = "Este ID ya fue agregado";
                this.oMensajeDetalle.bMostrar = true;
                return false;
            }

            //ahora validamos si viene por rango y si alguno de esos ids se encuentra para 
            let aRangoIds = this.sBuscador?.split("-");
            if(aRangoIds?.length==2){
                let nValorInicial = aRangoIds[0];
                let nValorFinal = aRangoIds[1];
                // Validar que ambos sean números
                if (isNaN(nValorInicial) || isNaN(nValorFinal)) {
                    this.oMensajeDetalle.sMensaje = "El rango de ids no es correcto";
                    this.oMensajeDetalle.bMostrar = true;
                    return false;
                }

                // Convertir a enteros
                nValorInicial = parseInt(nValorInicial, 10);
                nValorFinal = parseInt(nValorFinal, 10);

                const aRango = [];

                // Crear el rango (ascendente o descendente)
                if (nValorInicial <= nValorFinal) {
                    for (let i = nValorInicial; i <= nValorFinal; i++) {
                        aRango.push(i);
                    }
                } else {
                    for (let i = nValorInicial; i >= nValorFinal; i--) {
                        aRango.push(i);
                    }
                }

                let bEncontrado = false;
                aRango.forEach(nIdElementoItem => {
                    let oTemp = this.aDatosEncontrados.find(item => item.idElemento == nIdElementoItem);
                    if(oTemp){
                        bEncontrado = true;
                    }
                });

                if(bEncontrado){
                    this.oMensajeDetalle.sMensaje = "Un ID ya se encuentra agregado";
                    this.oMensajeDetalle.bMostrar = true;
                    return false;
                }

            }

            return true;
        }
    }
}
</script>

<style scoped>
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
.alertInformativo{
    margin-top: 14px;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 8px;
    background: linear-gradient(135deg, rgba(0, 86, 211, 0.05) 0%, rgba(239, 246, 255, 0.3) 100%);
    border: 1.26px solid #0056D333;
    font-family: "Poppins";
    color:#1447E6;
}
.alertInformativo2{
    margin-top: 14px;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 8px;
    background: #FFFBEB;
    border: 1.26px solid #FFD230;
    font-family: "Poppins";
    color:#973C00;
}
.alertError{
    margin-top: 14px;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 8px;
    background: #f7e3e3;
    border: 1.26px solid red;
    font-family: "Poppins";
    color:red;
}
.btnBuscador{
    background-color: #2196F3 !important;
    border-radius: 8px;
    height: 48px;
    width: 48px;
    box-shadow: 0 2px 4px rgba(33, 150, 243, 0.3);
}
.textoBusqueda{
    font-size: medium;
    color: black;
}
.elemento{
    color:#016630;
    cursor: pointer;
}
.elementoError{
    color:#9F0712;
    cursor: pointer;
}


.custom-scroll {
    overflow-y: scroll !important;
    overflow-x: hidden !important;
}

/* Estilizar el scrollbar */
.custom-scroll::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}

</style>
